// extracted by mini-css-extract-plugin
export var content = "information-banner-module--content--b06ad";
export var image = "information-banner-module--image--8d4c8";
export var imageSvg = "information-banner-module--imageSvg--1893b";
export var informationBanner = "information-banner-module--informationBanner--23332";
export var picto = "information-banner-module--picto--e3e55";
export var text = "information-banner-module--text--f24d2";
export var title = "information-banner-module--title--3e92d";